import { gql } from "@apollo/client";

import CommonGoalArtifactFragment from "@graphql/common-goal-artifact-fragment";

export const AverageAssessmentAnswersByProgramFragment = gql`
  fragment AverageAssessmentAnswersByProgram on AverageAssessmentAnswersByProgramNode {
    averageAnswer
    maxRange
    submittedDatetime
    minRange
    program {
      id
      title
      assessmentDeliveries(
        targetId: $profileId
        first: 1
        state_In: [delivered]
      ) {
        edges {
          node {
            id
          }
        }
      }
    }
  }
`;

const CompetencyGoalFragment = gql`
  ${CommonGoalArtifactFragment}
  fragment CompetencyGoalFragment on GoalArtifactNode {
    ...CommonGoalArtifactFragment
    competencyRelations(roleId: $roleId) {
      edges {
        node {
          id
          competencyId
          roleId
        }
      }
    }
  }
`;

export default gql`
  ${CompetencyGoalFragment}
  ${AverageAssessmentAnswersByProgramFragment}

  fragment CareerTableRoleFragment on CareerTrackRoleNode {
    id
    competencies {
      edges {
        node {
          id
          averageAssessmentAnswersByProgram(
            roleId: $roleId
            targetId: $profileId
          ) {
            ...AverageAssessmentAnswersByProgram
          }
        }
      }
    }
    developmentGoals(goalOwners: [$profileId], goalStates: [open, draft]) {
      edges {
        node {
          ...CompetencyGoalFragment
        }
      }
    }
    responsibilityAverageAssessmentAnswersByProgram(targetId: $profileId) {
      ...AverageAssessmentAnswersByProgram
    }
  }

  query getCareerRoleRelatedDataQuery($roleId: Int!, $profileId: Int!) {
    careerRole(id: $roleId) {
      id
      ...CareerTableRoleFragment
    }
  }
`;
